//import config from 'config';
import { BehaviorSubject } from 'rxjs';
import { /* config, */ authHeader, handleResponse } from '../_helpers';

const currentUserInfoSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('userInfo')));

export const userService = {
    getAll,
    getMe,
    getGroup,
    currentUserInfo: currentUserInfoSubject.asObservable(),
    get currentUserInfoValue () { return currentUserInfoSubject.value }
};

function getAll() {
    const requestOptions = { method: 'GET', headers: authHeader(), redirect: 'follow' };
    return fetch(`${window.config.HostUrlAuth}usuario/`, requestOptions).then(handleResponse);
}

async function getMe() {
    const requestOptions = { method: 'GET', headers: authHeader(), redirect: 'follow' };

    const userInfo= await fetch(`${window.config.HostUrlAuth}usuario/me`, requestOptions).then(handleResponse);

    localStorage.setItem('userInfo', JSON.stringify(userInfo));

    return userInfo;
}

async function getGroup() {
    const requestOptions = { method: 'GET', headers: { "Content-Type": "application/json"} };

    const userGrupo= await fetch(`${window.config.HostUrlAuth}grupo`, requestOptions).then(handleResponse);

    localStorage.setItem('userInfo', JSON.stringify(userGrupo));

    return userGrupo;
}
